import { useState } from "react";

import Drawer from "@vapor/react-material/Drawer";
import CircularProgress from "@vapor/react-material/CircularProgress";
import Box from "@vapor/react-material/Box";
import Stack from "@vapor/react-material/Stack";
import AppBar from "@vapor/react-material/AppBar";
import Typography from "@vapor/react-extended/ExtendedTypography";
import IconButton from "@vapor/react-material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { EMBED_CLOSE_MSG, EMBED_READY_MSG } from "./use-embed-page";
import { EmbedIFrame } from "../components/EmbedIFrame";

export const useEmbedDrawer = (targetUrn, config = {}) => {
  // Controls the open/close state:
  const [isOpen, setIsOpen] = useState(false);
  const [wasOpen, setWasOpen] = useState(config.preload);
  const [isReady, setIsReady] = useState(false);

  const close = () => setIsOpen(false);
  const open = () => {
    setWasOpen(true);
    setIsOpen(true);
  };

  const api = { isOpen, open, close };

  const {
    title = null,
    scope = "popup",
    params = {},
    events = {},
    width = "35vw",
    anchor = "right",
    LoadingComponent = CircularProgress,
    loadingComponentProps = {},
    drawerProps = {},
    iframeProps = {}
  } = config;

  // Wrap all the events with auto-close behavior:
  Object.keys(events).forEach((evt) => {
    const fn = events[evt];
    events[evt] = (data) => {
      if (fn(data, api) !== false) {
        close();
      }
    };
  });

  // Add Drawer API events:
  events[EMBED_READY_MSG] = () => setIsReady(true);
  events[EMBED_CLOSE_MSG] = close;

  return {
    ...api,
    el: (
      <Drawer
        {...drawerProps}
        onClose={close}
        open={isOpen}
        keepMounted={wasOpen}
        anchor={anchor}
      >
        {typeof title === "string" ? (
          <AppBar position="static">
            <Stack direction="row" sx={{ ml: 2, alignItems: "center" }}>
              <Typography sx={{ flexGrow: 1 }}>{title}</Typography>
              <IconButton color="inherit" size="large" onClick={close}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </AppBar>
        ) : (
          title
        )}
        {isReady ? null : (
          <Box
            sx={{
              width,
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <LoadingComponent {...loadingComponentProps} />
          </Box>
        )}
        <EmbedIFrame
          {...iframeProps}
          src={targetUrn}
          scope={scope}
          params={params}
          events={events}
          style={{
            ...(iframeProps.style || {}),
            width,
            flex: 1,
            display: isReady ? "block" : "none"
          }}
        />
      </Drawer>
    )
  };
};
